import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { ILeadFormModel } from '../../../typings'
import { useFormikContext, useField } from 'formik'
import { useCallback, useMemo, useEffect } from 'react'
import { ISalesFunnel } from '@user/store/salesFunnel'

import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

type Props = {
  name: string
  salesFunnels: ISalesFunnel[]
  required?: boolean
}

export function useData(props: Props) {
  const { name, salesFunnels, required } = props
  const tidalThemeActive = useTidalThemeActive()

  const {
    setFieldValue,
    isSubmitting,
    values: { salesFunnelId },
  } = useFormikContext<ILeadFormModel>()

  const [{}, { error, touched }] = useField<string[]>({
    name,
    validate: (value) => {
      if (required !== undefined ? required : true && !value) {
        return 'Required'
      }
    },
  })

  const showError =
    required !== undefined
      ? Boolean(required && error && touched)
      : Boolean(error && touched)
  const helperText = showError ? error : ''

  const options = salesFunnels

  const getLabel = useCallback(
    (option: ISalesFunnel) =>
      option.isDefault ? `(Default) ${option?.name}` : option?.name,
    [],
  )

  const getId = useCallback((option: ISalesFunnel) => {
    return String(option.id)
  }, [])

  const initialOption = useMemo(() => {
    if (salesFunnelId) {
      const value = salesFunnels.find((x) => x.id == salesFunnelId)

      if (value) return value
    }

    if (!salesFunnelId && required == undefined) {
      const value = salesFunnels.find((x) => x.isDefault)
      if (value) return value
    }
    return null
  }, [salesFunnels, salesFunnelId, required])

  useEffect(() => {
    if (!salesFunnelId && required == undefined) {
      const value = options.find((x) => x.isDefault)
      if (value) {
        setFieldValue('salesFunnelId', value.id)
      }
    }
  }, [salesFunnelId, required])

  const density: DensityType = tidalThemeActive ? 'comfortable' : 'compact'

  return {
    getLabel,
    getId,
    items: options,
    initialOption,
    isSubmitting,
    showError,
    helperText,
    density,
  }
}
